"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Children } from "react";
import { cn } from "../../../utils/index.js";
import { Span } from "../../Text/Span.js";
import { cleanTableProps } from "../cleanTableProps.js";
import { useTableContext } from "../Table/index.js";
import { TableBodyContext } from "./TBody.context.js";
import { tBodyVariants } from "./TBody.variants.js";
function TBody({ children, className, ...props }) {
    const { maxColumns: tableMaxColumns } = useTableContext();
    const { maxColumns: tableBodyMaxColumns } = props;
    const maxColumns = tableBodyMaxColumns ?? tableMaxColumns;
    const classes = cn(tBodyVariants(props), className);
    const hasChildren = Children.toArray(children).some((child)=>null !== child);
    const cleanedProps = cleanTableProps(props);
    return /*#__PURE__*/ jsx(TableBodyContext.Provider, {
        value: props,
        children: /*#__PURE__*/ jsxs("tbody", {
            className: classes,
            ...cleanedProps,
            children: [
                children,
                !hasChildren && /*#__PURE__*/ jsx("tr", {
                    className: "h-35",
                    children: /*#__PURE__*/ jsx("td", {
                        className: "size-full place-content-center justify-center",
                        colSpan: maxColumns,
                        children: /*#__PURE__*/ jsx("div", {
                            className: "flex justify-center text-body2 text-neutral-10",
                            children: /*#__PURE__*/ jsx(Span, {
                                children: "No Data Available"
                            })
                        })
                    })
                })
            ]
        })
    });
}
export { TBody };
